/**
 * Should not process keyboard shortcuts if the current active element is
 * either an INPUT, TEXTAREA or LI (MenuItems of MUI selects).
 *
 * NOTE: The video progress slider is itself an input element, so it is excluded from this check.
 */
const shouldNotProcessShortcuts = (): boolean =>
  (document.activeElement?.tagName === 'INPUT' &&
    document.activeElement?.getAttribute('name') !== 'video-progress-slider') ||
  document.activeElement?.tagName === 'TEXTAREA' ||
  document.activeElement?.tagName === 'LI';

export default shouldNotProcessShortcuts;
